import {css} from 'lit';
export const styles = css`:host {
  --bg: var(--contrast-light);
  --bg-hover: var(--gray-200);
  --bg-active: var(--gray-300);
  --color: var(--dark-text);
  --color-secondary: var(--dark-text-secondary);
  --avatar-size: 44px;
}

  :host .wrapper {
    background-color: var(--bg);
    border-radius: 6px;
  }

  :host a.wrapper {
    display: block;
    color: var(--color);
  }

  @media (hover: hover) {
      :host a.wrapper:hover {
        background-color: var(--bg-hover);
      }
    }

  :host a.wrapper:active {
      background-color: var(--bg-active);
    }

  :host header,
  :host [name='title']::slotted(*) {
    padding: 20px 16px;
  }

  :host header {
    display: flex;
    border-bottom: 1px solid var(--border-light);
  }

  :host header > ef-icon {
      font-size: var(--font-size-xl);
    }

  :host .content {
    flex: 1 1 auto;
    padding-left: 8px;
    padding-right: 8px;
    min-width: 1px;
  }

  :host .content h3 {
      margin-top: 0;
      margin-bottom: 0;
      font-size: var(--font-size-md);
    }

  :host .info {
    display: flex;
    color: var(--color-secondary);
  }

  :host ef-timeago {
    white-space: nowrap;
  }

  :host ::slotted(xs-origin) {
    min-width: 1px;
    padding-left: 8px;
    margin-left: 4px;
    border-left: 1px solid var(--border-light-secondary);
  }

  :host [name='title']::slotted(*) {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  :host [name='title']::slotted(*) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export default styles;
